module.exports = __webpack_public_path__ + "img/img3.91dde12f.png";